// React
import React, {useState, useEffect} from "react";

// Components
// import { Upload, Icon, message } from "antd";

// Libs
import * as EventifyAPI from "../libs/EventifyAPI";

// UUID
const uuidv4 = require("uuid/v4");

// DateTime
const { DateTime } = require("luxon");

const ListHistoryFeed = React.forwardRef((props, ref) => {
  const [listHistory, setListHistory] = useState([]);
  const [reloadProtocol, setReloadProtocol] = useState(null);

  React.useImperativeHandle(ref, () => ({
    setCurrentListId: (currentListId) => {
      console.log(currentListId);
      EventifyAPI.getHistoryForListId(
        currentListId
      ).then( (result) => {
        // const sorted = result.sort( (a, b) => { return a.updated > b.updated ? -1 : 1});
        setListHistory(result.reverse());
        setReloadProtocol(uuidv4());
      })
    },
  }));

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone(
      "America/Los_Angeles"
    );
    const timeString = timeObject.toLocaleString(DateTime.DATETIME_MED);
    return <p>{timeString}</p>;
  }

  function renderHistoryBlock(history) {
    return (
      <div className="history-activity-block">
        <p className="activity-description">
          {history.description}
        </p>
        {/*<div className="activity">
          <p>
            {history.activity}
          </p>
        </div>*/}
        <p className="timestamp">{formatTime(history.updated)}</p>
      </div>
    )
  }

  function renderHistories(histories) {
    return (
      <>
        {histories.map((history, n) => renderHistoryBlock(history))}
      </>
    )
  }

  return (
    <div className="list-history-feed">
      <h4>List Activity</h4>
      <div className="list-history-content-container">
        {renderHistories(listHistory)}
      </div>
    </div>
  );
});

export default ListHistoryFeed;
